import { render } from "./PageDersNotuAta.vue?vue&type=template&id=399538b6"
import script from "./PageDersNotuAta.vue?vue&type=script&lang=js"
export * from "./PageDersNotuAta.vue?vue&type=script&lang=js"
script.render = render

export default script